module.exports = __webpack_public_path__ + "img/10@2x.1b401490.png";